import { styled } from 'styled-components';
const StyledDescriptionList = styled.dl.withConfig({
  componentId: "aui__sc-93mjx2-0"
})(["display:flex;margin-top:0;flex-direction:column;"]);
export { StyledDescriptionList };